import React from 'react';
import { ALL_ROUTES } from '../../../../routes/dashboard/overview/AllPathNames';
import { useNavigate } from 'react-router-dom';
import { RavenTab } from '@ravenpay/raven-bank-ui';
import { colorToRgba } from '../../../../utils/helper/Helper';

interface myComponentProps {
	activeTabIndex?: string;
	setActiveTabIndex?: (param?: any) => void;
}

const ComplianceTabLink = ({
	activeTabIndex,
	setActiveTabIndex,
}: myComponentProps) => {
	const navigate = useNavigate();

	const listToUse = [
		{
			label: 'BVN Verification',
			active: location?.pathname === ALL_ROUTES?.COMPLIANCE_BVN_VERIFICATION,
			value: ALL_ROUTES?.COMPLIANCE_BVN_VERIFICATION,
			onClick: () => {
				if (activeTabIndex !== ALL_ROUTES?.COMPLIANCE_BVN_VERIFICATION) {
					setActiveTabIndex &&
						setActiveTabIndex(ALL_ROUTES?.COMPLIANCE_BVN_VERIFICATION);
					navigate(ALL_ROUTES?.COMPLIANCE_BVN_VERIFICATION);
				}
			},
		},
		{
			label: 'NIN Verification',
			active: location?.pathname === ALL_ROUTES?.COMPLIANCE_NIN_VERIFICATION,
			value: ALL_ROUTES?.COMPLIANCE_NIN_VERIFICATION,
			// component: <ComplianceNinVerification />,
			onClick: () => {
				if (activeTabIndex !== ALL_ROUTES?.COMPLIANCE_NIN_VERIFICATION) {
					setActiveTabIndex &&
						setActiveTabIndex(ALL_ROUTES?.COMPLIANCE_NIN_VERIFICATION);
					navigate(ALL_ROUTES?.COMPLIANCE_NIN_VERIFICATION);
				}
			},
		},
		{
			label: 'Address Verification',
			active:
				location?.pathname === ALL_ROUTES?.COMPLIANCE_ADDRESS_VERIFICATION,
			value: ALL_ROUTES?.COMPLIANCE_ADDRESS_VERIFICATION,
			// component: <ComplianceAddressVerification />,
			onClick: () => {
				if (activeTabIndex !== ALL_ROUTES?.COMPLIANCE_ADDRESS_VERIFICATION) {
					setActiveTabIndex &&
						setActiveTabIndex(ALL_ROUTES?.COMPLIANCE_ADDRESS_VERIFICATION);
					navigate(ALL_ROUTES?.COMPLIANCE_ADDRESS_VERIFICATION);
				}
			},
		},
		{
			label: 'CAC Verification',
			active: location?.pathname === ALL_ROUTES?.COMPLIANCE_CAC_VERIFICATION,
			value: ALL_ROUTES?.COMPLIANCE_CAC_VERIFICATION,
			// component: <ComplianceCacVerification />,
			onClick: () => {
				if (activeTabIndex !== ALL_ROUTES?.COMPLIANCE_CAC_VERIFICATION) {
					setActiveTabIndex &&
						setActiveTabIndex(ALL_ROUTES?.COMPLIANCE_CAC_VERIFICATION);
					navigate(ALL_ROUTES?.COMPLIANCE_CAC_VERIFICATION);
				}
			},
		},
	];

	return (
		<>
			{/* reusable tab start */}
			<RavenTab
				activeBgColor={colorToRgba('var(--primary-base-color)', 0.1)}
				activeColor="var(--primary-base-color)"
				list={listToUse}
				style={{ marginTop: '0rem' }}
			/>
			{/* reusable tab end */}
		</>
	);
};

export default ComplianceTabLink;
